import React from 'react'
import { type ProductList } from 'types/products/productTypes'
import { OrderCategories, PharmacyPartners } from '../common'

type Input = { productList: ProductList[]; category: string }

export function useIsMoudDeliveryAvailable({ productList, category }: Input) {
  const deliveryProductsTypes = React.useMemo(() => {
    // @ts-expect-error TS7034 -- MIGRATION: not approved, fix when encountered
    let standardProducts = []
    // @ts-expect-error TS7034 -- MIGRATION: not approved, fix when encountered
    let thriveProducts = []
    const deliveryProducts = productList.flatMap((pL) => pL.Products.filter((p) => p.IsPharmacyPickupAllowed === false))
    if (deliveryProducts && category === OrderCategories.moud) {
      thriveProducts = deliveryProducts.filter((deliveryProduct) =>
        deliveryProduct.Options.some((option) => option.PharmacyPartner === PharmacyPartners.thrive.name),
      )
      standardProducts = deliveryProducts.filter((deliveryProduct) =>
        deliveryProduct.Options.some(
          (option) =>
            option.PharmacyPartner === PharmacyPartners.honeybee.name ||
            option.PharmacyPartner === PharmacyPartners.pharmacyHub.name,
        ),
      )
    }
    // @ts-expect-error TS7005 -- MIGRATION: not approved, fix when encountered
    return { thriveProducts, standardProducts }
  }, [category, productList])
  return {
    isMoudDeliveryAvailable:
      (deliveryProductsTypes.thriveProducts.length || deliveryProductsTypes.standardProducts.length) &&
      category === OrderCategories.moud,
    standardProducts: deliveryProductsTypes.standardProducts,
    thriveProducts: deliveryProductsTypes.thriveProducts,
  }
}
